module.exports = __webpack_public_path__ + "static/img/LibralCapital.228d24e2.png";